import { FieldMetaState } from 'react-final-form'
import { isEqual, transform } from 'lodash'

export function diff<T extends { [key: string]: any }>(object: T, base: T) {
  function changes(object: T, base: T) {
    return transform(object, (result: { [key: string]: any }, value, key) => {
      if (!isEqual(value, base[key])) {
        if (Array.isArray(value) && Array.isArray(base[key])) {
          result[key] = value

          return
        }

        result[key] = typeof value === 'object' && typeof base[key] === 'object' ? changes(value, base[key]) : value
      }
    })
  }

  return changes(object, base)
}

export const checkFieldError = <FieldValue>(
  meta: Pick<FieldMetaState<FieldValue>, 'dirtySinceLastSubmit' | 'error' | 'submitError' | 'submitting' | 'touched'>
): string | boolean | undefined => {
  if (meta.touched && meta.error) {
    return meta.error
  }

  if (meta.submitting) {
    return false
  }

  if (!meta.dirtySinceLastSubmit) {
    return meta.submitError
  }

  return false
}

export const getFieldErrorMessage = (errorValue: string | boolean | undefined) => {
  if (typeof errorValue === 'boolean' || !errorValue) {
    return undefined
  }

  return String(errorValue)
}
